package com.hyperether.planner.ui

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathEffect
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Constraints
import com.hyperether.planner.model.DashboardPlan
import com.hyperether.planner.model.Event
import com.hyperether.planner.model.Plan
import com.hyperether.planner.util.Dp
import com.hyperether.planner.util.Sp
import com.hyperether.planner.util.horizontalScrollbar
import com.hyperether.planner.util.verticalScrollbar
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant


@Composable
fun DashboardDayPlanner(
    listOfPlans: MutableList<Plan>,
    startHour: Int = 8,
    screenWidth: Float = 0f,
    screenHeight: Float = 0f,
    isMobileView: Boolean,
    onEventClicked: (Event) -> Unit
) {
    println("DashboardDayPlanner screenWidth:  $screenWidth")
    var celWidth = 80.0f
    val eventCount = listOfPlans.sumOf { it.events.size }
    println("Scheduler recompose eventCount: $eventCount")
    var calculatedWidth = celWidth * eventCount - 40f
    println("DashboardDayPlanner calculatedWidth: $calculatedWidth  eventCount: $eventCount")
    if (screenWidth > 0 && eventCount > 0) {
        if (screenWidth > calculatedWidth) {
            // more space available:
            calculatedWidth = screenWidth
            if (!isMobileView) {
                calculatedWidth = calculatedWidth - 310f // dashboard
                calculatedWidth = 0.6f * calculatedWidth // split with map
            }
            calculatedWidth = calculatedWidth - 80f // Adjust width to account for the time column
            calculatedWidth = calculatedWidth - 40f // Adjust width to account for the right margin
            if (calculatedWidth < 0)
                calculatedWidth = 0f
            celWidth = calculatedWidth / eventCount
            println("DashboardDayPlanner new calculatedWidth: $calculatedWidth  celWidth: $celWidth")
        }
    } else {

    }
//    val celWidthDp by remember { mutableStateOf(celWidth) }
//    val tableWidth by remember { mutableStateOf(Dp(calculatedWidth)) }
    val events by mutableStateOf(
        listOfPlans.flatMap { it.events }.toMutableList().also { eventList ->
            // Ensure that listOfPlans has at least 10 items (with default events if needed)
//            if (eventList.size < 10) {
//                while (eventList.size < 10) {
//                    eventList.add(
//                        Event(
//                            jobId = null,
//                            status = EventStatus.DRAFT,
//                            from = Clock.System.now()
//                                .toLocalDateTime(TimeZone.currentSystemDefault()),
//                            to = null,
//                            title = null,
//                            color = Color.Transparent
//                        )
//                    )
//                }
//            }

            eventList.sortBy { it.from.hour }
        })

    println("DashboardDayPlanner celWidth: $celWidth tableWidth:$calculatedWidth events.size: ${events.size}")
    val horizontalScrollState = rememberScrollState()
    val verticalScrollState = rememberScrollState()

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .verticalScrollbar(verticalScrollState)
            .let { modifier ->
                if (screenWidth > 0)
                    modifier
                else
                    modifier.horizontalScrollbar(horizontalScrollState)
            }
            .pointerInput(Unit) {
                detectDragGestures { change, dragAmount ->
                    change.consume()
                    CoroutineScope(Dispatchers.Default).launch {
                        verticalScrollState.scrollTo(verticalScrollState.value - dragAmount.y.toInt())
                        horizontalScrollState.scrollTo(horizontalScrollState.value - dragAmount.x.toInt())
                    }
                }
            }
            .fillMaxSize()
            .background(Color.White),
        contentAlignment = Alignment.TopStart
    ) {
        Row {
            // Left column with time slots
            Column(
                modifier = Modifier.verticalScroll(verticalScrollState)
                    .background(Color.Transparent)
            ) {
                val listOfHours = generateHourlyTimeSlots(startHour)
                listOfHours.forEach { dashboardEvent ->
                    Box(
                        modifier = Modifier
                            .height(Dp(50f))
                            .width(Dp(80f))
                            .background(Color.Transparent),
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            dashboardEvent.time,
                            textAlign = TextAlign.Center,
                            color = Color.Gray,
                            fontSize = Sp(14f)
                        )
                    }
                }
            }

            val density = LocalDensity.current
            val hourHeightDp = Dp(50f)
            val textMeasurer = rememberTextMeasurer()
            println("DashboardDayPlanner Canvas celWidth: $celWidth tableWidth:$calculatedWidth events.size: ${events.size}")

            // Column with events
            Column(
                modifier = Modifier
                    .horizontalScroll(horizontalScrollState)
                    .verticalScroll(verticalScrollState)
            ) {
                Canvas(
                    modifier = Modifier
                        .offset(y = -Dp(20f))
                        .size(
                            width = Dp(calculatedWidth),
                            height = hourHeightDp * (24 - startHour)
                        )
                        .pointerInput(events) {
                            detectTapGestures { tapOffset ->
                                with(density) {
                                    val hourHeight = hourHeightDp.toPx()
                                    val eventWidth = Dp(celWidth).toPx()

                                    events.forEachIndexed { index, event ->
                                        event.to?.let { dueTime ->
                                            val xOffset = index * eventWidth
                                            val startHourRelative = event.from.hour - startHour + 1
                                            val startMinuteRelative = event.from.minute
                                            val topLeftY =
                                                (startHourRelative * hourHeight) + (startMinuteRelative * hourHeight / 60)
                                            val durationMinutes =
                                                calculateDurationInMinutes(event.from, dueTime)
                                            val eventHeightForDuration =
                                                (hourHeight * durationMinutes) / 60f

                                            val rectLeft = xOffset
                                            val rectTop = topLeftY
                                            val rectRight = xOffset + eventWidth
                                            val rectBottom = topLeftY + eventHeightForDuration

                                            if (tapOffset.x in rectLeft..rectRight && tapOffset.y in rectTop..rectBottom) {
                                                onEventClicked(event)
                                                return@detectTapGestures
                                            }
                                        }
                                    }
                                }
                            }
                        }
                ) {
                    with(density) {
                        val hourHeight = hourHeightDp.toPx()
                        val eventWidth = Dp(celWidth).toPx()
                        println("DashboardDayPlanner celWidth: $celWidth eventWidth:$eventWidth density: $density")
                        val pathEffect = PathEffect.dashPathEffect(floatArrayOf(5f, 5f), phase = 0f)

                        // Draw hour lines
                        for (i in 0..24 - startHour) {
                            drawLine(
                                color = Color.Gray,
                                start = Offset(0f, i * hourHeight),
                                end = Offset(size.width, i * hourHeight),
                                pathEffect = pathEffect
                            )
                        }

                        // Draw events
                        // TODO: set Offset for other statues
                        events.forEachIndexed { index, event ->
                            event.to?.let { dueTime ->
                                val xOffset = index * eventWidth
                                // Calculate Y position based on start time
                                val startHourRelative = event.from.hour - startHour + 1
                                val startMinuteRelative = event.from.minute
                                val topLeftY =
                                    (startHourRelative * hourHeight) + (startMinuteRelative * hourHeight / 60)

                                // Calculate event box height based on duration
                                val durationMinutes =
                                    calculateDurationInMinutes(event.from, dueTime)
                                val eventHeightForDuration = (hourHeight * durationMinutes) / 60f

                                // Draw the event box
                                println("DashboardDayPlanner xOffset: $xOffset eventWidth:$eventWidth topLeftY: $topLeftY")
                                val padding = 8f
                                val rectWidth = eventWidth - 2 * padding
                                val rectStart = xOffset + padding
                                drawRoundRect(
                                    color = event.color,
                                    topLeft = Offset(rectStart, topLeftY),
                                    size = Size(
                                        width = rectWidth,
                                        height = eventHeightForDuration
                                    ),
                                    cornerRadius = CornerRadius(10f, 10f)
                                )

                                val textWidth = rectWidth - 2 * padding
                                val textStart = rectStart + padding
                                // Draw the event title centered within the event box
                                val measuredText = textMeasurer.measure(
                                    AnnotatedString(event.title ?: ""),
                                    constraints = Constraints.fixedWidth(textWidth.toInt()),
                                    overflow = TextOverflow.Ellipsis,
                                    style = TextStyle(
                                        fontSize = Sp(12f),
                                        color = Color.Black,
                                        textAlign = TextAlign.Center
                                    ),
                                    maxLines = 1
                                )

                                // Position the title within the event box
                                val textOffsetX =
                                    textStart + (textWidth - measuredText.size.width) / 2
                                val textOffsetY =
                                    topLeftY + (eventHeightForDuration - measuredText.size.height) / 2
                                drawText(measuredText, topLeft = Offset(textOffsetX, textOffsetY))
                            }
                        }
                    }
                }
            }
        }
    }
}

fun generateHourlyTimeSlots(startTme: Int): List<DashboardPlan> {
    val timeSlots = mutableListOf<DashboardPlan>()
    for (hour in startTme until 24) {
        val formattedTime = "${hour.toString().padStart(2, '0')}:00"
        timeSlots.add(DashboardPlan(time = formattedTime, listOf()))
    }
    return timeSlots
}

fun calculateDurationInMinutes(from: LocalDateTime, to: LocalDateTime): Long {
    val fromInstant = from.toInstant(TimeZone.currentSystemDefault())
    val toInstant = to.toInstant(TimeZone.currentSystemDefault())
    val duration = toInstant - fromInstant
    return duration.inWholeMinutes
}
